import React, { Component, Fragment } from "react";
import jwtAuthService from "../services/jwtAuthService";
import localStorageService from "../services/localStorageService";
import history from "history.js";
import ConstantList from "../appConfig";
import axios from "axios";
import { toast } from "react-toastify";
import UserService from "app/services/UserService";

let timeout;

class Auth extends Component {
  state = {
    getUserComplete: false,
  };

  constructor(props) {
    super(props);

    axios.interceptors.request.use(async (config) => {
      try {
        await UserService.updateToken(() => {
          config.headers.Authorization = `Bearer ${UserService.getToken()}`;
          return Promise.resolve(config);
        });

      } catch (err) {
        console.error("Cannot refresh token", err);
        UserService.doLogin();
      }

      return config;
    });

    axios.interceptors.response.use(
      (response) => {
        // if (timeout) {
        //   clearTimeout(timeout);
        // }

        // timeout = setTimeout(() => {
        //   toast.warning("Phiên đăng nhập hết hạn, vui lòng đăng nhập lại.");
        //   jwtAuthService.setSession(null);
        //   jwtAuthService.removeUser();
        //   setTimeout(() => jwtAuthService.logout(), 3000);
        // }, 7200000);

        return response;
      },
      (error) => {
        console.error("Axios interceptor caught error:", error);
        const status = error?.response?.status;
        if (status === 401) {
          toast.warning("Phiên đăng nhập đã hết hạn. Đăng xuất...");
          jwtAuthService.setSession(null);
          jwtAuthService.removeUser();
          setTimeout(() => jwtAuthService.logout(), 3000);
          return Promise.reject(error);
        } else if (!/\d/.test(error)) {
          // toast.warning('Có lỗi khi kết nối đến máy chủ.');
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );

    if (ConstantList.AUTH_MODE === "Keycloak") {
      let userToken = localStorageService.getItem("auth_token");
      if (userToken != null) {
        jwtAuthService.setSession(userToken);
        // jwtAuthService.getAllSysConfigKey();
        jwtAuthService.getAllSysConfigKey().then(() => {
          jwtAuthService
            .getCurrentUser()
            .finally(() => this.setState({ getUserComplete: true }));
        });
      } else {
        history.push(ConstantList.LOGIN_PAGE);
      }
    } else {
      let user = localStorageService.getItem("auth_user");
      if (user != null) {
        jwtAuthService.setSession(user.token);
      } else {
        history.push(ConstantList.LOGIN_PAGE);
      }
    }
  }

  render() {
    const { children } = this.props;
    const { getUserComplete } = this.state;
    if (ConstantList.AUTH_MODE === "Keycloak") {
      return getUserComplete && <Fragment>{children}</Fragment>;
    } else {
      return <Fragment>{children}</Fragment>;
    }
    // if (ConstantList.AUTH_MODE === "Keycloak" && !this.state.getUserComplete) {
    //   console.log(this.state.getUserComplete)
    //   return <></>
    // }
    // else{
    //   return this.props.children
    // }
  }
}

export default Auth;
